import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { AddCommentInput } from '../../../shared/models/lead/addComment.input';
import { LeadService } from '../../../shared/services/lead/lead.service';
import { ToastService } from '../../../shared/services/utils/toast.service';
import { LeadsComunicationService } from '../../leads/leads-comunication.service';
import { ModalsHandlerService } from '../modals.handler.service';

@Component({
  selector: 'ngx-comment-modal',
  templateUrl: './comment-modal.component.html',
  styleUrls: []
})
export class CommentModalComponent implements OnInit, AfterViewInit {

  @ViewChild('content', { static: false }) content: Element;
  commentForm: FormGroup;
  commentLeadInput: AddCommentInput;
  sending = false;

  constructor(
    private readonly modalsHandler: ModalsHandlerService,
    private readonly modalService: NgbModal,
    private readonly formBuilder: FormBuilder,
    private readonly leadService: LeadService,
    private readonly toastService: ToastService,
    private readonly leadComuService: LeadsComunicationService
  ) {
  }

  ngOnInit(): void {
    this.commentForm = this.formBuilder.group({
      comments: [{ value: '' }, [Validators.required]]
    });
  }

  ngAfterViewInit(): void {
    this.modalsHandler.commentLeadModal.subscribe(leadId => {
      this.commentLeadInput = new AddCommentInput();
      this.commentLeadInput.leadId = leadId;
      this.modalService
        .open(this.content, {
          size: 'lg',
          container: 'nb-layout',
          ariaLabelledBy: 'modal-basic-title',
          backdrop: 'static', keyboard: false
        });
    });
  }

  sendComment(): void {
    this.sending = true;

    if (this.commentForm.invalid) {
      this.sending = false;
      return;
    }

    this.leadService.addComment$(this.commentLeadInput).subscribe(() => {
      this.leadComuService.launchReloadMyLead(this.commentLeadInput.leadId);
      this.modalService.dismissAll();
      this.toastService.showToast('success', 'toaster.add_comment.success.title', 'toaster.add_comment.success.body');
      this.sending = false;
    }, error => {
      this.toastService.showToast('error', 'toaster.add_comment.error.title', error.message);
      this.sending = true;
    });
  }

}
